import axiosInstance from '../../Helpers/api_helper';

export const getNigerianUniversities = async (): Promise<any> => {
  try {
    const response = await axiosInstance.get('api/v1/participants/nigerianUniversities');
    return response.data;
  } catch (error: any) {
    console.error('Error getting Nigerian universities:', error.message);
    throw error;
  }
};
